'use client';

import { departmentsSection } from '@stereoagency/sanity-schema';
import useSWR from 'swr';
import { useContext } from 'react';
import { profilesQuery } from './profilesQuery';
import UIDepartmentsSection from './DepartmentsSection.client';
import extractAllProfilesFromDepartments from './extractAllProfilesFromDepartments';
import { SanityDraftClientContext } from '@/components/context';

type Props = typeof departmentsSection.schema.departmentsSection;

export default function DraftModeDepartmentsSection({
  title,
  subtitle,
  departments
}: Props) {
  const profileIds = extractAllProfilesFromDepartments(departments ?? []);
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR(`profiles-${profileIds.join('-')}`, () =>
    client?.fetch<(typeof profilesQuery)[1]>(profilesQuery[0])
  );

  return (
    <UIDepartmentsSection
      title={title}
      subtitle={subtitle}
      departments={departments}
      profiles={data ?? []}
    />
  );
}
